import { companyProfileFlows } from './companyProfile';

export default { ...companyProfileFlows };
